import axios from "axios"
import { baseUrl } from "../../assets/Animations"


export const moveWaitlistToScheduling = (familyId, callback) => {
    axios.post(`${baseUrl}/move-waitlist-to-scheduling`, {
        familyId: familyId,
    })
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const makeInquired = (familyId, callback, typeOfConfirmationPopup) => {
    axios.post(`${baseUrl}/make-inquired/${familyId}`)
    .then((res) => {
        callback(res.data, typeOfConfirmationPopup)
    })
    .catch((err) => console.log(err))
}

export const moveToWaitlist = (familyId, callback) => {
    axios.post(`${baseUrl}/make-waitlist/${familyId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const moveCardToScheduling = (familyId, cardId, callback) => {
    axios.post(`${baseUrl}/move-card-to-scheduling/${familyId}/${cardId}`)
    .then((res) => {
        callback(res.data, cardId)
    })
    .catch((err) => console.log(err))
}

export const deleteTheCard = (cardId, callback) => {
    axios.delete(`${baseUrl}/delete-card/${cardId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const moveToOnboarding = (cardId, callback) => {
    axios.post(`${baseUrl}/move-card-to-onboarding/${cardId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const moveToIntro = (cardId, callback) => {
    axios.post(`${baseUrl}/move-card-to-intro/${cardId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const moveToOffboard = (cardId, callback) => {
    axios.post(`${baseUrl}/move-card-to-offboard/${cardId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}

export const deleteInquiryCardAndDeleteTheFamily = (cardId, familyId, callback, typeOfConfirmationPopup) => {
    axios.delete(`${baseUrl}/delete-inquiry-card-and-delete-family/${cardId}/${familyId}`)
    .then((res) => {
        callback(res.data, typeOfConfirmationPopup)
    })
    .catch((err) => console.log(err))
}

export const completeOnboardingCard = (card, callback) => {
    axios.post(`${baseUrl}/complete-onboarding-card/${card.todoId}/${card.familyId}`)
    .then((res) => {
        callback(res.data)
    })
    .catch((err) => console.log(err))
}